import React from "react";
import {CCol, CFormInput, CFormLabel, CFormText, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import {applyFilter} from "../../store/slice/component/table";

const NoteSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    return <>
        <CRow>
            <CCol>
                <CFormLabel>Note</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'note',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.note || ''}
                />
                <CFormText>Example: Its a great day.</CFormText>
            </CCol>
        </CRow>
    </>;
}

export default NoteSearch;
